module.exports = __webpack_public_path__ + "static/media/logo_white.d952aab1.svg";